module.exports = __webpack_public_path__ + "d292af7cfb908a435b94edc5c0080d83.png";